export const sort = (data, field) =>
  data?.sort((a, b) => new Date(b?.[field]) - new Date(a?.[field]))
